define('views/modules/calendar/animated-session/animation/rename/custom-names-manager-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/calendar/session/renamed-animations',
    // Views
    'views/parts/list/fetch-list',
    'views/modules/calendar/animated-session/animation/rename/list/custom-name-list-item',
    'views/modules/calendar/animated-session/animation/rename/edit/custom-name-edit-panel',
    // Templates Blocks
    'text!templates/modules/calendar/animated-session/animation/rename/custom-names-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // collections
    CRenamedAnimations,
    // Views
    VFetchList,
    VCustomNameListItem,
    VCustomNameEditPanel,
    // Template
    TCustomNamesContent
) {

    var VCustomNamesManagerContent = Backbone.View.extend({
        template: TCustomNamesContent,
        regions: {
            root: '#custom-names-content',
            list: "#custom-names-list",
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.group = this.options.group;

            var collection = this.collection = new CRenamedAnimations(null, {
                group: this.group.id
            });

            this.view = {
                list: new VFetchList({
                    collection: collection,
                    item: VCustomNameListItem,
                    async: false,
                    button: {
                        label: 'Show more custom names'
                    },
                    bottom: true
                }),
            };

            this.listenTo(collection, { "custom:name:click": this.onCustomNameClick });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list);

            this.collection.fetch();

            return this;
        },

        /////////////
        // Actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onCustomNameClick: function(model) {
            var view = this.view,
                panel = view.edit || (view.edit = new VCustomNameEditPanel());
            panel.setModel(model);
            this.trigger('panel:stack', panel);
        },

    });

    return VCustomNamesManagerContent;

});

